import axios from 'axios';
import Cookies from "js-cookie"
const ConfigBaseURL = 'https://competitions.cgagolf.org.cn/tour' //默认路径，这里也可以使用env来判断环境
//const ConfigBaseURL = 'http://192.168.0.39:8085/tour' //默认路径，这里也可以使用env来判断环境
//const ConfigBaseURL = 'http://golftourweb.1rock.cc/tour' //默认路径，这里也可以使用env来判断环境
const getToken = Cookies.get('imToken')



// axios 配置

var service = axios.create({

	headers: {
		'Content-Type': 'application/json',
		'Authorization': 'Bearer ' + Cookies.get('imToken'),
	},
	timeout: 900000,
	baseURL: ConfigBaseURL, //接口请求地址
})


// 添加请求拦截器
service.interceptors.request.use(config => {
	config.headers['Accept-Language'] = localStorage.getItem('language');
	return config
}, error => {
	// 对请求错误做些什么
	return Promise.reject(error);
})

// 添加响应拦截器
service.interceptors.response.use(response => {
	if (response.status === 200) {

		switch (response.data.code) {
			case 401: // token过期，重新登录


				localStorage.setItem('code', response.data.code)
				Cookies.remove('imToken')
				// localStorage.removeItem('code')
				location.href = "/login"
				break;
		}
		return Promise.resolve(response);

	} else {

		return Promise.reject(response);
	}
	//对错误代码做处理
}, error => {
	// 对响应错误做点什么C



	if (error.response.status) {
		switch (error.response.status) {
			// 401: 未登录
			// 未登录则跳转登录页面，并携带当前页面的路径
			// 在登录成功后返回当前页面，这一步需要在登录页操作。
			case 401:

				break;
				// 403 token过期
				// 登录过期对用户进行提示
				// 清除本地token和清空vuex中token对象
				// 跳转登录页面
			case 403:

				break;
				// 404请求不存在
			case 404:

				break;
			case 500:

				break;
		}

	} else {

	}
	return Promise.reject(error);
});

export default service;

/**
 * post 请求方法
 */
export function post(url, data = {}) {
	return new Promise((resolve, reject) => {
		service.post(url, data).then(response => {
			//对接口错误码做处理
			resolve(response.data);
		}, err => {
			reject(err);
		})
	})
}

/**
 * get 请求方法
 */
export function get(url, data = {}) {
	return new Promise((resolve, reject) => {
		service.get(url, {
				params: data
			})
			.then(response => {
				resolve(response);
			})
			.catch(err => {
				reject(err)
			})
	})
}

/**
 * 封装所有请求
 */
export function request(methed, url, data = {}, headers) {
	return new Promise((resolve, reject) => {
		service({
				method: methed.method || 'post',
				url: methed.url,
				params: methed.method === 'get' ? methed.data : '',
				data: methed.method !== 'get' ? methed.data : '',
				headers: headers || {
					'Content-Type': 'application/json;charset=UTF-8',
					'Authorization': 'Bearer ' + Cookies.get('imToken'),
				},
				responseType: methed.responseType || ''
			})
			.then(response => {
				//对接口错误码做处理
				resolve(response);
			})
			.catch(err => {
				reject(err)
			})
	})
}


/**
 * 下载Excel, 后端发送post请求，使用blob格式
 * @param {Object} url
 * @param options 参数
 * @param fileName  文件名，默认时间戳形式
 */
export function exportExcel(url, data = {}, headers, fileName) {
	return new Promise((resolve, reject) => {
		service({
				method: 'post',
				url: url,
				data: data,
				headers: headers || {
					'Content-Type': 'application/json;charset=UTF-8',
					'Authorization': 'Bearer ' + Cookies.get('imToken'),
				},
				responseType: 'blob' // 表明返回服务器返回的数据类型
			})
			.then(response => {
				// resolve(response.data)

				//在下载前先读取
				const f = new FileReader() //创建一个文件对象
				f.readAsText(response.data) // 以文本的方式读取文件
				//执行 onload方法
				f.onload = () => {
					// 这里使用 try catch 方式捕获异常
					try {
						const result = JSON.parse(f
							.result
						) // f.result为读取结果，如果 JSON.parse()报错，说明后端返回的数据是 正常的 文件流  在catch中进行下载

					} catch (error) {
						// 解析数据流
						let blob = new Blob([response.data], {
								type: 'application/vnd.ms-excel'
							}),
							link = document.createElement('a'),
							href = window.URL.createObjectURL(blob)
						link.href = href
						link.download = fileName + '.xlsx'
						document.body.appendChild(link)
						link.click()
						document.body.removeChild(link)
						window.URL.revokeObjectURL(href)
					}
				}

			})
			.catch(err => {
				reject(err)
			})
	})
}


// WEBPACK FOOTER //
// ./src/utils/request.js